import * as types from './types';
import { get } from 'lodash';
import { fetchPost } from '../api/fetch';
import { openSnackBar } from './snackbarAction';
import { logOut } from '../actions/loginActions';

export function onDashboardData(response) {
  return {
    type: types.DASHBOARD_RESPONSE,
    response,
  };
}

export function onLoginProfileData(response) {
  return {
    type: types.LOGIN_PROFILE_RESPONSE,
    response,
  };
}

export const dashboardApi = (jwtToken, dispatch) => {
  const url = 'api/student/dashboard';
  fetchPost(url, {}, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error && !Object.keys(data).includes('data')) {
        return dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' }),
        );
      }
      if (!get(data, 'IsLoggedIn', true)) {
        dispatch(
          openSnackBar({
            message: 'Multiple logins detected, please login again to continue',
            severity: 'warning',
          }),
        );
        return dispatch(logOut());
      }

      return dispatch(onDashboardData(data));

      //   if (!isEmpty(get(data, 'data.message.MessageTitle', false))) {
      //     setMessage(get(data, 'data.message', {}));
      //     handleClickOpen();
      //   }
    });
};
